<template>
  <div class="bdgWrp">
    <div class="profit-wrp">
      <el-table
          :data="tableData"
          border
          style="width: 100%">
        <el-table-column
          width="152"
          prop="weekEnding"
          label="WEEK ENDING">
        </el-table-column>
        <el-table-column
          prop="actualRevenue"
          label="ACTUAL REVENUE">
          <template slot-scope="scope">
            ${{scope.row.actualRevenue}}
          </template>
        </el-table-column>
        <el-table-column
          prop="wages"
          label="WAGES">
          <template slot-scope="scope">
            ${{scope.row.wages}}
          </template>
        </el-table-column>
        <el-table-column
          prop="hrs"
          label="HRS">
        </el-table-column>
        <el-table-column
          prop="profit"
          label="PROFIT">
          <template slot-scope="scope">
            ${{scope.row.profit}}
          </template>
        </el-table-column>
        <template slot="empty">
          <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
          <div v-else>-</div>
        </template>
      </el-table>
      <pageination :total="totalRecord" :size="pagesize" @togglePage="pageChange"></pageination>
    </div>
  </div>
</template>

<script>
import api from '../../../api/account'
import pageination from '../../../components/common/pageination'

export default {
  data () {
    return {
      loading: true,
      tableData: [],
      page: 1,
      pagesize: 10,
      totalRecord: 0
    }
  },
  created() {
    if (!this.$route.params.id) {
      return
    }
    api.profit({
      params: {
        venueId: parseInt(this.$route.params.id),
        pageNum: this.page,
        pageSize: this.pagesize
      },
      callback: this.callback
    })
  },
  methods: {
    callback (res) {
      var that = this
      that.loading = false
      if(res.data.code == 0){
        res.data.data.list.forEach(item => {
          item.hrs = that.$box.formatDecimal2(item.hrs, 2)
          item.profit = that.$box.formatDecimal2(item.profit, 2)
          item.actualRevenue = that.$box.formatDecimal2(item.revenueTarget, 2)
          item.wages = that.$box.formatDecimal2(item.wages, 2)
        })
        that.tableData = res.data.data.list
        that.totalRecord = res.data.data.total
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    pageChange (page) {
      this.tableData = []
      this.loading = true
      this.page = page
      api.profit({
      params: {
        venueId: parseInt(this.$route.params.id),
        pageNum: this.page,
        pageSize: this.pagesize
      },
      callback: this.callback
    })
    }
  },
  components: {
    pageination
  }
}
</script>

<style lang="scss" scoped>
.bdgWrp{
  width: 100%;
  margin-bottom: 30px;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
  .profit-wrp{
    width: 100%;
    background: #151C27;
    margin-bottom: 50px;
    padding-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/profit/index.vue